import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from "react-redux";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { fetchFeaturePermissions } from 'src/reducers/permissionsReducer';
import { Tooltip, Checkbox } from 'antd';
const AppTabsComponent = ({ screenName,handleChange,customClass,handleCheckboxChange,checked}) => {
    const path = window.location.pathname?.split('/')?.[3];
    const navigate = useNavigate();
    const menuItems = useSelector((store)=> store?.permissions?.menuItems)
    const Permissions = useSelector((store) => store.permissions?.featurePermissions?.[screenName]?.permissions);
    const [state, setState] = useState({ moduleName: ''})
 
  const dispatch = useDispatch();
    useEffect(() => {
        const exists = menuItems?.some(item => item.screenName?.toLowerCase() === screenName?.toLowerCase());
        if(!exists&&menuItems){
            navigate(`/accessdenied`)
        }else{
            if (!Permissions) {
                const perObj = menuItems?.find(item => item.screenName.toLowerCase()==screenName.toLowerCase())
                 dispatch(fetchFeaturePermissions(perObj?.screenName, perObj?.id))
            } else {
                const _tabName=path||state.moduleName
                if (_tabName) {
                    let _obj = Permissions?.tabs?.find((item) => item?.name === _tabName);
                        if(!_obj?.isEnabled||(_obj.actions?.[0]?.name === 'View' && _obj.actions[0].isEnabled === false)){
                            handleChange(_tabName,true)
                            setState((prev) => ({ ...prev, moduleName: _tabName  }));
                        }else{
                            handleChange(_tabName ,false)
                            setState((prev) => ({ ...prev, moduleName: _tabName  }));
                        }
                }else{
                        const defObj = Permissions.tabs?.find(item => (item.isEnabled || (item.actions?.[0]?.name === 'View' && item.actions[0].isEnabled)));
                        handleChange(defObj?.name,defObj?.name?false:true)
                        setState((prev) => ({ ...prev, moduleName: defObj?.name}));
                }
            }
        }
    }, [Permissions])
    const handleCheckbox = (e) => {
        handleCheckboxChange(e);
      };
 
    return (<>
        <div className="">
            <Tabs
                defaultActiveKey={state?.moduleName}
                id="fill-tab-example"
                className={`flex md:gap-2 border-b border-light-secondaryColor ${customClass}`}
                activeKey={state?.moduleName}
                onSelect={(key)=>{handleChange(key);setState((prev) => ({ ...prev, moduleName: key }));}}
              
            >
                {Permissions?.tabs?.map((item) => (item.isEnabled && <Tab key={item.name} eventKey={item.name} title={<div className="flex items-center gap-1"><span>{item.name}</span><div className="flex items-center gap-0.5">{item.name === 'Cases' &&<Tooltip title="Click the checkbox to view my cases"><span className="icon info"></span></Tooltip>}{item.name === 'Cases' &&<Checkbox checked={checked} onChange={handleCheckbox}  className="checkbox-size"/>}</div></div>} className="pb-1">
                </Tab>))}
            </Tabs>
        </div>
    </>
    )
}
export default AppTabsComponent